import React from "react";
import { useData } from "../context/DataContext";

export default function useStockProduit(id, stock) {
	const { commandeEnCours } = useData();
	const [stockProduit, setStockProduit] = React.useState(null);

	React.useEffect(() => {
		const sortingStockEnVente = async () => {
			let totalCommande = [];

			Object.entries(commandeEnCours).forEach(([key, value]) => {
				if (
					key !== "etag" &&
					key !== "partitionKey" &&
					key !== "rowKey" &&
					key !== "timestamp" &&
					key !== "open"
				) {
					JSON.parse(value).map((produit) => {
						return totalCommande.push(produit);
					});
				}
			});

			const stockTotal = await Object.values(
				totalCommande.reduce((acc, item) => {
					if (!acc[item.produit]) {
						acc[item.produit] = {
							produit: item.produit,
							quantite: item.quantite,
						};
					} else {
						acc[item.produit].quantite += item.quantite;
					}
					return acc;
				}, {})
			);

			setStockProduit(
				stockTotal.find((item) => item.produit === id)
					? stock -
							stockTotal.find((item) => item.produit === id)
								.quantite
					: stock
			);
		};
		if (stock && !stockProduit && commandeEnCours) {
			sortingStockEnVente();
		}
	}, [stockProduit, commandeEnCours, stock, id]);

	return { stockProduit };
}
/*const [quantiteCommander, setQuantiteCommander] = React.useState(null);

	const { commandeEnCours } = useData();

	React.useEffect(() => {
		id && stock && commandeEnCours && sortingStockEnVente();
	});

	const sortingStockEnVente = async () => {
		let totalCommande = [];

		Object.entries(commandeEnCours).forEach(([key, value]) => {
			if (
				key !== "etag" &&
				key !== "partitionKey" &&
				key !== "rowKey" &&
				key !== "timestamp" &&
				key !== "open"
			) {
				JSON.parse(value).map((produit) => {
					return totalCommande.push(produit);
				});
			}
		});

		const stockTotal = await Object.values(
			totalCommande.reduce((acc, item) => {
				if (!acc[item.produit]) {
					acc[item.produit] = {
						produit: item.produit,
						quantite: item.quantite,
					};
				} else {
					acc[item.produit].quantite += item.quantite;
				}
				return acc;
			}, {})
		);

		return setQuantiteCommander(stockTotal);
	};

	const [stockProduit, setStockProduit] = React.useState(null);

	React.useEffect(() => {
		if (!stockProduit && quantiteCommander) {
			const selectProduit = quantiteCommander.find(
				(item) => item.produit === id
			);

			selectProduit && setStockProduit(selectProduit.quantite);
		}
	}, [id, stockProduit, quantiteCommander]);

	//console.log(stockProduit);

	return { stockProduit };
}*/
